/* Desktop-only: hovering a colour swatch on a product card swaps the card's
   main image to that variant's photo; restores on mouse-out. Gated to devices
   with a real cursor — touch devices (phones, iPads) never activate this.
   Variant photos are prefetched the first time the cursor enters a card, so
   nothing extra is downloaded at page load.
   Combined listings: sibling swatches carry data-sibling-url instead of an
   image; on first card hover the sibling product's .js JSON is fetched and its
   featured image is used. */
(function () {
  if (window.__swatchHoverInit) return;
  window.__swatchHoverInit = true;
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  function mediaFor(swatch) {
    var card = swatch.closest('.card-wrapper');
    return card ? card.querySelector('.card__media .media') : null;
  }

  function prefetchCard(card) {
    card.querySelectorAll('.card-swatches__swatch').forEach(function (s) {
      var u = s.getAttribute('data-variant-image');
      if (u) {
        var im = new Image();
        im.src = u;
        return;
      }
      var pu = s.getAttribute('data-sibling-url');
      if (!pu) return;
      fetch(pu.split('?')[0] + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p || !p.featured_image) return;
          var url = p.featured_image;
          url += (url.indexOf('?') > -1 ? '&' : '?') + 'width=533';
          s.setAttribute('data-variant-image', url);
          var im = new Image();
          im.src = url;
        })
        .catch(function () {});
    });
  }

  document.addEventListener('mouseover', function (e) {
    if (!e.target.closest) return;

    // Prefetch this card's variant photos on first cursor entry
    var card = e.target.closest('.card-wrapper');
    if (card && !card.hasAttribute('data-swatch-prefetched')) {
      card.setAttribute('data-swatch-prefetched', '1');
      prefetchCard(card);
    }

    var swatch = e.target.closest('.card-swatches__swatch');
    if (!swatch) return;
    var url = swatch.getAttribute('data-variant-image');
    if (!url) return;
    var media = mediaFor(swatch);
    var img = media && media.querySelector('img');
    if (!img) return;
    if (!img.hasAttribute('data-orig-src')) {
      img.setAttribute('data-orig-src', img.getAttribute('src') || '');
      img.setAttribute('data-orig-srcset', img.getAttribute('srcset') || '');
    }
    media.classList.add('swatch-hovering');
    img.removeAttribute('srcset');
    if (img.getAttribute('src') !== url) img.setAttribute('src', url);
  });

  document.addEventListener('mouseout', function (e) {
    if (!e.target.closest) return;
    var swatch = e.target.closest('.card-swatches__swatch');
    if (!swatch) return;
    // Moving directly onto another swatch? Its mouseover will take over.
    if (e.relatedTarget && e.relatedTarget.closest && e.relatedTarget.closest('.card-swatches__swatch')) return;
    var media = mediaFor(swatch);
    var img = media && media.querySelector('img');
    if (!img || !img.hasAttribute('data-orig-src')) return;
    img.setAttribute('src', img.getAttribute('data-orig-src'));
    var ss = img.getAttribute('data-orig-srcset');
    if (ss) img.setAttribute('srcset', ss);
    media.classList.remove('swatch-hovering');
  });
})();
